const categoryByName = { // Used in AllListings page only
  News: 1,
  RoadWorksOrTraffic: 2,
  Events: 3,
  Clubs: 4,
  regionalProducts: 5,
  offerOrSearch: 6,
  newCitizenInfo: 7,
  defectReport: 8,
  lostAndFound: 9,
  companyPortraits: 10,
  carpoolingOrPublicTransport: 11,
  offers: 12,
  eatOrDrink: 13,
  rathaus: 14,
  newsletter: 15,
  officialnotification: 16,
  freetimeAndTourisms: 17,
  appointmentBooking: 18,
  defectReporter: 19,
  applicants: 20,
  energiedienstleistungen: 21,
  internetOfThings: 22,
  kommunaleWärmeplanung: 23,
  wasserstoff: 24,
  polls: 25,
  worthSeeing: 26,
  dekarbonisierung: 27,
  erzeugung: 28,
  handel: 29,
  fernwärme: 30,
  smartCity: 31,
  dynamischerTarif: 32,
  mobilität: 33,
  integration: 34,
  digitaleBürgerservices: 35,
  tourismus: 36,
  digitaleStadtplanung: 37,
  wirtschaftsförderung: 38,
  abfallwirtschaft: 39,
  bürgerbeteiligung: 40,
  highlights: 41,
  project: 42,
};

const categoryById = {
  1: "News",
  2: "RoadWorksOrTraffic",
  3: "Events",
  4: "Clubs",
  5: "Regional Products",
  6: "Offer / Search",
  7: "New citizen info",
  8: "DefectReport",
  9: "Lost and Found",
  10: "Company portraits",
  11: "Carpooling / Public transport",
  12: "Offers",
  13: "Eat or Drink",
  14: "rathaus",
  15: "newsletter",
  16: "officialnotification",
  17: "freetimeAndTourisms",
  18: "Appointment Booking",
  19: "DefectReporter",
  20: "Applicants",
  21: "Energiedienstleistungen",
  22: "Internet of Things / IoT",
  23: "KommunaleWärmeplanung",
  24: "Wasserstoff",
  25: "Polls",
  26: "WorthSeeing",
  27: "Dekarbonisierung",
  28: "Erzeugung",
  29: "Handel",
  30: "Fernwärme",
  31: "SmartCity",
  32: "DynamischerTarif",
  33: "Mobilität",
  34: "Integration",
  35: "DigitaleBürgerservices",
  36: "Tourismus",
  37: "DigitaleStadtplanung",
  38: "Wirtschaftsförderung",
  39: "Abfallwirtschaft",
  40: "Bürgerbeteiligung",
  41: "Highlights",
  42: "Project",
};

module.exports = { categoryByName, categoryById };